import type { ReactNode } from "react";

import { tw } from "@/utils";
import { Modal, ModalClose, ModalContent, ModalHeader } from "./Modal";

interface SideModalProps {
  isOpen: boolean;
  onOpenChange?: (open: boolean) => void;
  children: ReactNode;
}

export const SideModal = ({
  isOpen,
  onOpenChange,
  children,
}: SideModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onOpenChange}>
      <ModalContent
        className={tw(
          "fixed right-0 top-0 z-50 h-full overflow-scroll border-l border-neutral-100 bg-white shadow-lg",
          "sm:rounded-l-lg",
        )}
      >
        <ModalHeader>
          <ModalClose />
        </ModalHeader>
        <div className="p-6">{children}</div>
      </ModalContent>
    </Modal>
  );
};
